import { useEffect, useState } from "react";
import { graphql, useMutation } from "react-relay";
import { useParams } from "react-router";
import { getNoneLayout } from "src/components/layout";

import type { SlackConnectPageConnectSlackUserMutation } from "./__generated__/SlackConnectPageConnectSlackUserMutation.graphql";
import SlackConnectError from "./SlackConnectError";
import SlackConnectLoad from "./SlackConnectLoad";
import SlackConnectSuccess from "./SlackConnectSuccess";

type PageState = "loading" | "success" | "error";

const connectSlackUserMutation = graphql`
  mutation SlackConnectPageConnectSlackUserMutation($input: ConnectSlackUserInput!) {
    connectSlackUser(input: $input) {
      success
      message
    }
  }
`;

function SlackConnectPage() {
  const { token } = useParams<{ token: string }>();
  const [state, setState] = useState<PageState>("loading");
  
  const [commitConnectSlackUser] = useMutation<SlackConnectPageConnectSlackUserMutation>(connectSlackUserMutation);

  useEffect(() => {
    // Validate token format
    if (!token || token.length < 10) {
      setState("error");
      return;
    }

    // Call the mutation automatically
    commitConnectSlackUser({
      variables: {
        input: { token }
      },
              onCompleted: (response) => {
          if (response.connectSlackUser.success) {
            setState("success");
          } else {
            setState("error");
          }
        },
      onError: () => {
        setState("error");
      }
    });
  }, [token, commitConnectSlackUser]);

  if (state === "loading") {
    return <SlackConnectLoad />;
  }

  if (state === "success") {
    return <SlackConnectSuccess />;
  }

  if (state === "error") {
    return <SlackConnectError />;
  }

  return null;
}

export default SlackConnectPage;

// Use no layout for standalone page
SlackConnectPage.getLayout = getNoneLayout;
